module.exports = __webpack_public_path__ + "20250721160708/img/wx.72443439.png";